let defaultState = ["铅笔"]
export default function (state = defaultState,action){
    return [...state]
}